import React, { useState, useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import "../../Styles/Header.css";
import Appbar from "../../Component/NavPannel/Appbar";
import AccountsLayout from "../../Component/Layouts/AccountsLayout";

const mdTheme = createTheme();

function Accounts() {
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex", height: "100vh" }}>
        <CssBaseline />
        <Appbar mainpage="Home" subpage="Accounts" />
        <AccountsLayout />
      </Box>
    </ThemeProvider>
  );
}

export default Accounts; 